import request from "@/utils/request";
const qs = require("qs");
import { MLMReport } from "@/utils/requestApi";

// progresss

export function listVisit(data) {
  return request({
    url: MLMReport() + "/report/visit/detail",
    method: "POST",
    data: qs.stringify(data)
  });
}



// WEBPACK FOOTER //
// ./src/api/listVisit.js